'use client';

/**
 * Client-module re-export of NextIntlClientProvider.
 *
 * Imported from a Server Component, `next-intl` resolves to an RSC wrapper
 * that inherits any prop you did not pass (formats, now, timeZone) from the
 * request config — and resolving that config reads request headers, which
 * opts EVERY route rendering the provider into dynamic rendering. That
 * silently turned ~420 static marketing pages into ƒ server-rendered ones.
 *
 * Re-exporting from a 'use client' module resolves the plain client provider
 * instead: no inheritance, no request access, static rendering preserved.
 * Callers must pass `locale` and `messages` explicitly (the root layout does).
 */
export { NextIntlClientProvider as ClientIntlProvider } from 'next-intl';
